export default "__VITE_ASSET__CVuOIeVq__"